import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { PATH_NAME } from '../../../../configs/pathName';
import RequestRemainingText from './RequestRemainingText';
import ShareButton from './ShareButton';

const Accessibility = dynamic(
  () => import('../../../modal/Accessibility.modal')
);

function OwnerButtonGroups({ folderId }: { folderId: string }) {
  const router = useRouter();
  const [openAccessibilityModal, setOpenAccessibilityModal] =
    useState<boolean>(false);

  return (
    <>
      <div
        className={`my-2 flex flex-shrink-0 flex-col gap-2 text-sm sm:flex-row sm:justify-end lg:text-base`}
      >
        <div className="h-fit w-full flex-1 md:flex-none lg:hidden">
          <RequestRemainingText />
        </div>
        <div className="w-full md:w-fit">
          <ShareButton onClick={() => setOpenAccessibilityModal(true)} />
        </div>
      </div>
      {openAccessibilityModal && (
        <Accessibility
          isVisible={openAccessibilityModal}
          toggleModal={() => setOpenAccessibilityModal(false)}
          folderId={folderId}
          redirectWhenFetchMemberListFailed={(_err: any) => {
            if (_err.response.data.statusCode === 403) {
              router.replace(PATH_NAME.MY_GROUPS);
            }
          }}
        />
      )}
    </>
  );
}
export default OwnerButtonGroups;
